<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <p class="category">{{category}}</p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>

          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="height: 2em"
              v-model="show_appid"
              multiple
              collapse-tags
              @change="changeTableLabel"
              placeholder="请选择显示appid">
              <el-option
                v-for="item in appid_list"
                :key="item.value"
                :label="item.text"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="display: inline-block;">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>

          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <el-switch
              style="display: block"
              v-model="value4"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="显示个人记录"
              inactive-text="显示全部记录">
            </el-switch>
            <div style="display: inline-block">
              <p-button type="info" plain @click="updateAPI" :disabled="my_disable">
                一键更新
              </p-button>
            </div>

          </div>
        </div>
        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    @selection-change="handleSelectionChange"
                    border
                    style="width: 100%">
            <el-table-column type="selection" v-model="course">
            </el-table-column>
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="400"
              fixed="right"
              class-name="td-actions"
              label="操作">
              <template slot-scope="props" v-if="props.row.address">
                <p-button type="success" size="sm" @click="downloadResource(props.row.address)">
                  <i>资源下载</i>
                </p-button>
                <p-button type="success" size="sm" @click="copyDoenloadUrl(props.row.address,$event)">
                  <i>复制链接</i>
                </p-button>
                <p-button type="success" size="sm" v-if="isCheck(props.row.is_check)"
                          @click="shurePack(props.row.id,$event)">
                  <i>马甲包确认</i>
                </p-button>
                <p-button type="danger" size="sm" v-if="isCheck(props.row.is_check)"
                          @click="delPack(props.row.id,$event)">
                  <i>马甲包删除</i>
                </p-button>
                <i v-if="!isCheck(props.row.is_check)">已确认</i>

              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import './SyptHistory.scss'
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import clip from 'src/util/clipboard'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'


  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default {
    watch: {
      'value4'() {
        this.getData()
      },
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
      'info_list'() {
        if (this.info_list.length > 0) {
          this.timer()
        } else {
          clearTimeout(this.timer)
        }
      },
    }
    ,
    components: {
      PPagination,
      Search,
    }
    ,
    computed: {
      queriedData() {
        return this.tableData
      }
      ,
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      }
      ,
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      }
      ,
      total() {
        // this.changeTotal(this.total_count)
        return this.total_count
      }
      ,
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      }
      ,
    }
    ,

    data() {//定义tabel
      return {
        my_disable: false,
        multipleTable: [],
        floor: "sypt",
        title: '第一事业部打包历史记录',
        category: '',
        categorySecond: '',
        selectTime: '',//选择的开始时间和结束时间
        dialogFormVisible: false,
        pagination: {//分页
          perPage: 30,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          page_count: 0,
          total: 0
        },
        status: [],
        searchQuery: '',//搜索值
        currentsearchType: '游戏id',
        searchType: ['游戏id', '游戏名', '操作者', '广点通ID', '头条ID', 'UCID', '快手ID'],//搜索字段
        tableLabel: [//列表
          {
            prop: 'id',
            label: '编号',
            minWidth: 80,
          },
          {
            prop: 'gameid',
            label: '游戏id',
            minWidth: 80
          },
          {
            prop: 'child_game_name',
            label: '游戏名',
            minWidth: 80
          },
          {
            prop: 'tt_id',
            label: '头条APPid',
            minWidth: 100
          },
          {
            prop: 'gdt_id',
            label: '广点通appid',
            minWidth: 100
          },
          {
            prop: 'ks_id',
            label: '快手appid',
            minWidth: 100
          },
          {
            prop: 'uc_id',
            label: 'UCappid',
            minWidth: 100
          },
          {
            prop: 'floor',
            label: '楼层归属',
            minWidth: 80
          },
          {
            prop: 'target_version',
            label: 'targetSDK',
            minWidth: 80
          },
          {
            prop: 'status',
            label: '状态',
            minWidth: 80
          },
          {
            prop: 'chennel_name',
            label: '渠道名称',
            minWidth: 80
          },
          {
            prop: 'Ptime',
            label: '打包时间',
            minWidth: 80
          },
          {
            prop: 'user',
            label: '操作者',
            minWidth: 80
          },
        ],
        tableData: [],//渲染table数据
        tableColumns: [],
        //获取游戏信息批量传输给后台
        course: [],
        info_list: [],
        total_count: 0,
        value4: true,
        show_appid: [],
        appid_list: [
          {
            value: 'tt_id',
            text: '头条APPid',
          },
          {
            value: 'gdt_id',
            text: '广点通appid',
          },
          {
            value: 'ks_id',
            text: '快手appid',
          },
          {
            value: 'uc_id',
            text: 'UCappid',
          },
        ],
      }
    }
    ,
    methods: {
      changeTableLabel() {
        let applist_value = [];
        this.appid_list.forEach((info) => {
          applist_value.push(info.value)
        });
        //取交集
        let unshow_appid_list = [];
        unshow_appid_list = applist_value.filter(v => !this.show_appid.includes(v));
        let temp_label = [];
        this.tableLabel.forEach((item) => {
          if (!unshow_appid_list.includes(item.prop)) {
            temp_label.push(item)
          }
        });

        this.tableColumns = [];
        this.tableColumns = temp_label;

      },
      timer() {
        return setTimeout(() => {
          this.refresh_data()
        }, 15000)
      }
      ,
      get_args() {
        if (this.$route.params) {
          if (this.$route.params.args) {
            let temp_gidlist = this.$route.params.args
            let exist_gidlist = localStorage.getItem("info_list")
            console.log(exist_gidlist)
            if (exist_gidlist.length > 0) {
              let arr = exist_gidlist.concat(temp_gidlist)
              let arr_temp = []
              for (let i = 0; i < arr.length; i++) {
                if (!arr_temp.includes(arr[i].target_version) && !arr_temp.includes(arr[i].gameid) && !arr_temp.includes(arr_temp[i].cid)) {
                  arr_temp.push(arr[i])
                }
              }
              this.info_list = arr_temp
            } else {
              localStorage.setItem("info_list", this.info_list);
              this.info_list = this.$route.params.args
            }
          }
        }
      }
      ,
      //局部刷新数据
      async refresh_data() {
        let opt = {
          url: '/api/sypt/package_information/',
          type: 'put',
          data: {info_list: this.info_list},
          //  如果需要接入第三方的接口，需要添加此参数
        }
        // console.log(opt.data)
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          if (res.data.package_informations) {
            console.log(res.data.package_informations)
          }
        }

      }
      ,

      handleSelectionChange(val) {
        this.multipleTable = val;               //  this.multipleTable 选中的值
        //console.log(val);
      }
      ,
      async updateAPI() {
        this.updateIds = []
        for (var i = 0; i < this.multipleTable.length; i++) {
          if (this.multipleTable[i].is_check) {
            this.updateIds.push({
              floor: this.floor,
              chennel_category: this.multipleTable[i].chennel_name,
              gid: this.multipleTable[i].gameid,
              target_version: this.multipleTable[i].target_version

            })
          } else {
            alert(this.multipleTable[i].child_game_name + "没有进行马甲包确认无法更新推广包")
            return;
          }

        }
        let opt = {
          url: "/api/apk/game_update/",
          type: "put",
          data: {
            args: this.updateIds,
          }
        }
        //console.log(opt.data)
        if (this.updateIds.length !== 0) {
          this.my_disable = ""
          const res = await getFetch(this, opt);
          if (res.code === 0) {
            this.my_disable = false
            alert("正在后台更新")
            this.getData()
          } else if (res.code === 6001) {
            this.my_disable = false
            alert(res.msg)
          } else {
            this.my_disable = false
            alert(res.msg)
          }
        } else {
          this.my_disable = false
          alert("请勾选游戏再进行更新")
        }

      }
      ,
      isCheck(check) {
        if (check) {
          return false
        } else {
          return true
        }
      }
      ,

      //资源下载
      downloadResource(url) {
        open(window.Config.host + "/download" + url)
      }
      ,
      //复制下载地址
      copyDoenloadUrl(text, event) {
        text = window.Config.host + "/download" + text
        clip(text, event)
      }
      ,
      //马甲包确认
      shurePack(id, event) {
        this.makeShureGameAPI(id)
      }
      ,
      cractAccount() {
        this.dialogFormVisible = true
      }
      ,
      changeTotal(length) {
        this.pagination.total = length
      }
      ,
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage
        let show_type = this.value4
        let req_data = {}
        req_data['size'] = size
        req_data['page'] = page
        req_data["show_type"] = show_type

        if (this.searchQuery !== '') {
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['gid'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[1]) {
            req_data['type'] = 2
            req_data['name'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[2]) {
            req_data['type'] = 4
            req_data['user'] = this.searchQuery
            // ['游戏id', '游戏名', '操作者', '广点通ID', '头条ID', 'UCID', '快手ID']
          } else if (this.currentsearchType === this.searchType[3]) {
            req_data['type'] = 5;
            req_data['gdt_id'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[4]) {
            req_data['type'] = 6;
            req_data['tt_id'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[5]) {
            req_data['type'] = 7;
            req_data['uc_id'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[6]) {
            req_data['type'] = 8;
            req_data['ks_id'] = this.searchQuery
          }
        }

        // req_data['show_type'] = true  //选择个人为true 全部为false

        let opt = {
          url: '/api/sypt/package_information/',
          type: 'get',
          data: req_data,
          //  如果需要接入第三方的接口，需要添加此参数
          // host:window.Config.homeHost
        }
        const res = await getFetch(this, opt);

        if (res.code === 0) {

          if (res.data.package_informations.total_count > 0) {
            let list = []
            let list1 = []
            let list2 = []
            var alllist = []
            for (var i = 0; i < res.data.package_informations.results.length; i++) {
              var data = res.data.package_informations.results[i]
              if (data.status == "1") {
                data.status = "成功"
              } else if (data.status == "0") {
                data.status = "失败"
              } else {
                data.status = "正在打包中"
              }
              if (data.floor == "sypt") {
                data.floor = "第一事业部"
              } else if (data.floor == "yypt") {
                data.floor = "第二事业部"
              }

              list.push(data)
            }
            for (let i = 0; i < list.length; i++) {
              if (list[i].status == "正在打包中") {
                list1.push(list[i])
              } else {
                list2.push(list[i])
              }
            }
            alllist = list1.concat(list2)
            this.tableData = alllist//res.data.package_informations.results
            this.changeTotal(res.data.package_informations.total_count)
            this.total_count = res.data.package_informations.total_count
            this.pagination.page_count = res.data.package_informations.total_page
            this.searchQuery = ''
          } else if (this.searchQuery) {
            this.searchQuery = ''
            alert("该搜索记录为空，请确定搜索条件是否正确")
          }
        }
      },
      delPack(id, event) {
        swal({
          title: '确定要删除此马甲包？',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: '是',
          cancelButtonText: '否',
          buttonsStyling: false
        }).then(() => {
          this.delApk(id);
        })
      },
      async delApk(id) {
        let opt = {
          url: "/api/sypt/package_information/",
          type: "delete",
          data: {
            pid: id,
          }
        };
        const res = await getFetch(this, opt);

        if (res.code === 0) {
          swal({
            title: '删除成功!',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
          this.getData();
        }
      },
      //马甲包确认API
      async makeShureGameAPI(id) {
        let opt = {
          url: "/api/sypt/package_information/",
          type: "post",
          data: {
            pid: id,
          }
        }
        const res = await getFetch(this, opt);

        if (res.code === 0) {
          this.getData();
        }
      }
      ,
      async getdata() {
        await this.changeTableLabel();
        await this.getData();
      },
    }
    ,
    mounted() {
      this.getdata();
      this.get_args();
      this.refresh_data()
    }
  }
</script>

